<template lang="pug">
  transition(name='fade')
    .messageview(v-show='display')
      p(v-bind:class='{danger: isError, warning: isWarning, success: isSuccess}')
        ul
          li(v-for='msg in messages') {{ msg }}
        a(v-show='!messageConfig.autoClose' href='javascript:void' @click='messageClose()') {{messageConfig.closeCaption}}
</template>

<script>
import bus from '@/service/EventBus'

export default {
  name: 'alert',
  data () {
    return {
      display: false,
      isError: false,
      isWarning: false,
      isSuccess: false,
      messages: [],
      messageConfig: {},
      defaultConfig: {
        autoClose: true,
        autoCloseTime: 5,
        closeCaption: '閉じる',
        closedExec: null
      }
    }
  },
  methods: {
    messageClose () {
      if (typeof this.messageConfig.closedExec === 'function') this.messageConfig.closedExec()
      this.display = false
    }
  },
  mounted () {
    // defaultConfigをセット
    this.messageConfig = this.defaultConfig

    bus.$on('show_message', (type, messages, config) => {
      this.isError = false
      this.isWarning = false
      this.isSuccess = false
      this.messages = []
      if (type === 'error') this.isError = true
      if (type === 'warn') this.isWarning = true
      if (type === 'success') this.isSuccess = true
      if (messages instanceof Array) {
        this.messages = messages
      } else {
        this.messages.push(messages)
      }
      // configのマージ
      config = Object.assign(this.defaultConfig, config || {})
      this.messageConfig = config

      // 自動で閉じる場合
      this.display = true
      if (this.messageConfig.autoClose) {
        setTimeout(() => {
          this.display = false
          if (typeof this.messageConfig.closedExec === 'function') this.messageConfig.closedExec()
        }, this.messageConfig.autoCloseTime * 1000)
      }
    })
    bus.$on('hide_message', () => {
      this.display = false
    })
  }
}
</script>

<style lang="stylus" scoped>
ul
  list-style-type: none
  padding 0px
  margin 0px

.messageview
  max-width: 500px
  z-index: 10000
  position: fixed
  top: 0
  right: 0
  left: 0
  margin: auto
  margin-top: 15px
  p
    color: #000
    font-weight: bold
    font-size: 12px
    padding: 10px 15px
    box-shadow: 0 2px 4px rgba(0,0,0,0.2)

.danger
  border: 2px solid #d9534f
  background: #ffa6a4
.warning
  border: 2px solid #f0ad4e
  background: #ffd79c
.success
  border: 2px solid #0bbb98
  background: #86efda

.fade-enter-active, .fade-leave-active
  transition: opacity 1s
.fade-enter, .fade-leave-to
  opacity: 0
</style>




// WEBPACK FOOTER //
// MessageView.vue?49644827